import { render, staticRenderFns } from "./StickerMicMuteButton.vue?vue&type=template&id=6acf7025&scoped=true"
import script from "./StickerMicMuteButton.vue?vue&type=script&lang=ts"
export * from "./StickerMicMuteButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerMicMuteButton.vue?vue&type=style&index=0&id=6acf7025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf7025",
  null
  
)

export default component.exports